import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, ClipboardListIcon, DownloadIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '01',
    icon: ClipboardListIcon,
    title: 'Complete the Investor Survey',
    description: "7 questions, ~3 minutes, anonymous. Tell us what you're looking for so we can continuously improve the quality of deals we source. No name or phone required."
  }, {
    number: '02',
    icon: SearchIcon,
    title: 'Browse the Deal Flow',
    description: 'Explore curated deals with real data — cash flow percentages, ROI, equity upside. Every deal is vetted and backed by quantified analysis.'
  }, {
    number: '03',
    icon: DownloadIcon,
    title: 'Download Report + Save Your ID',
    description: "Get the full Deal Report with detailed analysis. Save your unique Investor ID — reference it when you're ready to talk, and we'll pull your exact preferences."
  }];
  return <section id="how-it-works" className="py-24 bg-white" data-id="element-270" data-mp="2rm7g6upwjdcf">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271" data-mp="2mn38k8imlno7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-272" data-mp="2mki6pjibv7qg">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-navy mb-6" data-id="element-273" data-mp="369ircvi68vc0">
            How It Works
          </h2>
          <p className="text-xl text-slate max-w-3xl mx-auto" data-id="element-274" data-mp="3k9tkk56yem0c">
            Three simple steps to access institutional-grade deal flow in Cabo
            San Lucas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12" data-id="element-275" data-mp="1pwu7ojtyk5wr">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative" data-id="element-276" data-mp="1kz27l2j5tdhh" data-mpi={index}>
              {/* Connector Line (desktop only) */}
              {index < steps.length - 1 && <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-gold to-gold/20 -translate-x-1/2 z-0" data-id="element-277" data-mp="cr07c1ibtcr3" />}

              <div className="relative z-10 text-center" data-id="element-278" data-mp="lk3rstre2pv8">
                <div className="inline-flex items-center justify-center w-32 h-32 bg-gradient-to-br from-gold/20 to-gold/5 rounded-full mb-6 border-2 border-gold/30" data-id="element-279" data-mp="ljk8p9q05vfm">
                  <step.icon className="text-gold" size={48} data-id="element-280" data-mp="vhq6pg8ouhf7" />
                </div>

                <div className="mb-4" data-id="element-281" data-mp="15mzngtyg3tt8">
                  <span className="text-6xl font-serif font-bold text-gold/20" data-id="element-282" data-mp="15o19tukww2q9">
                    {step.number}
                  </span>
                </div>

                <h3 className="text-2xl font-serif font-semibold text-navy mb-4" data-id="element-283" data-mp="vnqyygmcn7e9">
                  {step.title}
                </h3>

                <p className="text-slate leading-relaxed" data-id="element-284" data-mp="ro9qrffjfw5e">{step.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}